import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { DatePipe } from '@angular/common';
import { PromptValuePipe } from './prompt-value.pipe';
import { LengthValuePipe } from './length-value.pipe';
import { NumberValuePipe } from './number-value.pipe';
import { EcertFormatPipe } from './ecertnl-format.pipe';
import { EcertReplacePipe } from './ecertnl-replace.pipe';

@NgModule({
  imports: [BrowserModule],
  declarations: [PromptValuePipe, LengthValuePipe, NumberValuePipe, EcertFormatPipe, EcertReplacePipe],
  exports: [PromptValuePipe, LengthValuePipe, NumberValuePipe, EcertFormatPipe, EcertReplacePipe],
  providers: [DatePipe, NumberValuePipe, PromptValuePipe],
})
export class PipesModule {}
